import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import GovermentView from 'components/pages/goverment'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
})

const data = [
  {
    id: 1, title: 'Bantuan Pemerintah', content: 'Kementerian Pendidikan dan Kebudayaan (Kemendikbud) telah memanfaatkan...', url: '',
  },
  {
    id: 2, title: 'Bantuan Sosial', content: 'Menindaklanjuti kegiatan Pemilihan Calon Mitra SIPLah Periode 2021-2023...', url: 'www.google.com',
  },
]

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('data', 'setData', {
    data,
    isFetching: false,
  }),
  withHandlers({

  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Goverment',
        activePage: 'goverment',
        activeSubPage: 'goverment',
      })
    },
  }),
)(GovermentView)
